import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    List,
    ListItemButton,
    ListItemText,
    Radio,
    Typography,
} from "@mui/material";
import React from "react";
import ButtonExit from "../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";
import {formatAddressOptionLabel} from "../../../utils/customerAddressUtils";

const chooseDialogActionsSx = {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
    boxSizing: "border-box",
    p: "1.25rem",
    pt: 0,
};

const fullWidthButtonSx = {
    width: "100%",
    maxWidth: "100%",
    justifyContent: "center",
    boxSizing: "border-box",
    "@media (max-width: 1450px)": {
        width: "100%",
        minWidth: 0,
    },
};

const selectModalActionsNarrowMq = "@media (max-width: 600px)";

const selectDialogActionsSx = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "12px",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
    px: "1.25rem",
    pb: "1.25rem",
    pt: 0,
    [selectModalActionsNarrowMq]: {
        flexDirection: "column-reverse",
        alignItems: "stretch",
    },
};

const selectModalButtonSx = {
    width: "auto",
    minWidth: "180px",
    justifyContent: "center",
    boxSizing: "border-box",
    flexShrink: 0,
    [selectModalActionsNarrowMq]: {
        width: "100%",
        minWidth: 0,
    },
    "@media (max-width: 1450px)": {
        width: "auto",
        minWidth: "180px",
    },
};

const OrderAddressChooseModal = ({
    open,
    title,
    hasCurrentAddress,
    hasExistingAddresses,
    loading,
    onClose,
    onSelectExisting,
    onCreateNew,
    onEditCurrent,
}) => (
    <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{
            sx: {
                borderRadius: "8px",
                overflow: "hidden",
            },
        }}
    >
        <DialogTitle sx={{textAlign: "center", pb: 1}}>{title}</DialogTitle>
        <DialogContent sx={{pt: 0, pb: 0, overflow: "hidden"}}>
            <Typography sx={{textAlign: "center", color: "text.secondary", mb: 2}}>
                Выберите действие с адресом
            </Typography>
            <Box sx={chooseDialogActionsSx}>
                {hasExistingAddresses && (
                    <ButtonAdd
                        text="Выбрать из существующих"
                        width="100%"
                        minWidth={0}
                        sx={fullWidthButtonSx}
                        disabled={loading}
                        onClick={onSelectExisting}
                    />
                )}
                <ButtonAdd
                    text="Создать новый"
                    width="100%"
                    minWidth={0}
                    sx={fullWidthButtonSx}
                    disabled={loading}
                    onClick={onCreateNew}
                />
                {hasCurrentAddress && (
                    <ButtonAdd
                        text="Редактировать текущий"
                        width="100%"
                        minWidth={0}
                        sx={fullWidthButtonSx}
                        disabled={loading}
                        onClick={onEditCurrent}
                    />
                )}
                <ButtonExit text="Отменить" width="100%" sx={fullWidthButtonSx} onClick={onClose}/>
            </Box>
        </DialogContent>
    </Dialog>
);

const OrderAddressSelectModal = ({
    open,
    title,
    addressList,
    selectedAddressId,
    loading,
    onClose,
    onSelectedAddressIdChange,
    onConfirm,
    onEditSelected,
    onCreateNew,
}) => (
    <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="md"
        PaperProps={{
            sx: {
                borderRadius: "8px",
                overflow: "hidden",
            },
        }}
    >
        <DialogTitle sx={{textAlign: "center", pb: 1}}>{title}</DialogTitle>
        <DialogContent sx={{pt: 0, pb: 0, overflow: "hidden"}}>
            <List sx={{maxHeight: "50vh", overflowY: "auto", mb: 2, px: "0.25rem"}}>
                {addressList.map((option) => {
                    const optionId = String(option.id);
                    return (
                        <ListItemButton
                            key={option.id}
                            selected={selectedAddressId === optionId}
                            onClick={() => onSelectedAddressIdChange(optionId)}
                        >
                            <Radio checked={selectedAddressId === optionId} value={optionId}/>
                            <ListItemText
                                primary={formatAddressOptionLabel(option)}
                                sx={{ml: 1}}
                            />
                        </ListItemButton>
                    );
                })}
            </List>
            <Box sx={selectDialogActionsSx}>
                <ButtonExit text="Отменить" width={180} minWidth={180} sx={selectModalButtonSx} onClick={onClose}/>
                <ButtonAdd
                    text="Редактировать"
                    width={180}
                    minWidth={180}
                    sx={selectModalButtonSx}
                    disabled={loading || !selectedAddressId}
                    onClick={onEditSelected}
                />
                <ButtonAdd
                    text="Создать новый"
                    width={180}
                    minWidth={180}
                    sx={selectModalButtonSx}
                    disabled={loading}
                    onClick={onCreateNew}
                />
                <ButtonAdd
                    text="Выбрать"
                    width={180}
                    minWidth={180}
                    sx={selectModalButtonSx}
                    loading={loading}
                    disabled={loading || !selectedAddressId}
                    onClick={onConfirm}
                />
            </Box>
        </DialogContent>
    </Dialog>
);

export {OrderAddressChooseModal, OrderAddressSelectModal};
